import AddIcon from '@material-ui/icons/Add'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import MenuIcon from '@material-ui/icons/Menu'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import UploadIcon from '@material-ui/icons/VerticalAlignTop'
import FastForwardIcon from '@material-ui/icons/FastForward'
import FastRewindIcon from '@material-ui/icons/FastRewind'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import TodayIcon from '@material-ui/icons/Today'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import BlockedIcon from '@material-ui/icons/Block'
import LockedIcon from '@material-ui/icons/Lock'
import HomeIcon from '@material-ui/icons/Home'

const icons = {
  add: AddIcon,
  edit: EditIcon,
  delete: DeleteIcon,
  menu: MenuIcon,
  moreVert: MoreVertIcon,
  upload: UploadIcon,
  fastNext: FastForwardIcon,
  fastPrevious: FastRewindIcon,
  next: ChevronRightIcon,
  previous: ChevronLeftIcon,
  today: TodayIcon,
  arrowBack: ArrowBackIcon,
  arrowForward: ArrowForwardIcon,
  blocked: BlockedIcon,
  locked: LockedIcon,
  home: HomeIcon,
}

export default icons